// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"931c70dc","453":"20278bbf","455":"28d8506c","977":"195b697e"}[chunkId] + ".chunk.js";
};